
import Vue from 'vue'

export default Vue.extend({
  name: 'TopHeaderStatic',
  props: {
    currentSite: {
      type: String,
      required: true,
      default: ''
    }
  }
})
